import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'
import style from '../../../rootStyles/Options.module.css'
import HeaderRight from '../../../components/HeaderRight/HeaderRight'

const Options = () => {
    
    const theme = useAppSelector<string>(state => state.theme.theme)

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme ?? 'light'].secondBackground
            }}
        >
            <HeaderRight
                icon={null}
                title={null}
            />
            <div
                className={style.content}
                style={{
                    borderLeft: `1px solid ${Colors[theme ?? 'light'].borderLight}`
                }}
            >
            </div>
        </div>
    )
}

export default Options